import { XsI18nPipe } from '@nx-fe/pipes';

export class MemoryAndDateUtils {
    public static memorySize = (num: number, decimal: number) => {
        const type = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const base = 1024;
        let val: number | string = 0;
        let exp = 0;
        if (num > 0) {
            exp = Math.floor(Math.log(num) / Math.log(base));
            if (exp > type.length - 1) {
                exp = type.length - 1; // max supported value
            }
            val = num / Math.pow(2, exp * 10);
        }

        if (decimal <= 0 || Math.round(val) === val) {
            val = Math.round(val);
        } else {
            val = val.toFixed(decimal);
        }
        return val + ' ' + type[exp];
    }

    public static parseDate = (dateString) => {
        // json date '/Date(1444939010772)/'
        if (/\/Date\([0-9]+\)\//ig.test(dateString)) {
            return new Date(parseInt(dateString.substr(6), 10));
        } else {
            // TODO: add more acceptable date formats
            throw new Error('Date format not supported: ' + dateString);
        }
    }

    public static timeAgo = (date: number, $filter: XsI18nPipe) => {
        const periods = {
            year: { interval: 31536000, msg: ['message_TimeAgoYear', 'message_TimeAgoYears'] },
            month: { interval: 2592000, msg: ['message_TimeAgoMonth', 'message_TimeAgoMonths'] },
            day: { interval: 86400, msg: ['message_TimeAgoDay', 'message_TimeAgoDays'] },
            hour: { interval: 3600, msg: ['message_TimeAgoHour', 'message_TimeAgoHours'] },
            minute: { interval: 60, msg: ['message_TimeAgoMinute', 'message_TimeAgoMinutes'] }
        };
        const seconds = Math.floor((<any>new Date() - date) / 1000);
        let interval: number;
        let msg: string;
        let period: { interval: number, msg: string[] };
        for (let key in periods){
            let p = periods[key];
            interval = Math.floor(seconds / p.interval);
            if (interval >= 1) {
                period = p;
            }
        }

        if (period !== undefined) {
            msg = interval === 1 ? period.msg[0] : period.msg[1];
            return $filter.transform(msg, interval);
        } else {
            return $filter.transform('message_UpdatedJustNow');
        }
    }

    public static combineUrlSegments = (...urlSegments: string[]) => {
        let result: string;
        urlSegments.forEach(segment => {
            if (!result) {
                result = segment;
            } else {
                result = (result.endsWith('/'))
                    ? result.substring(0, result.length - 1)
                    : result;
                result += (segment.startsWith('/'))
                    ? segment
                    : '/' + segment;
            }
        });
    }
}
